'use client';

import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

export const useReverseProposalDetail = (reverseProposalId: number | undefined) => {
  return useQuery({
    ...curatorQueries.campaigns.reverseProposalDetail({
      reverseProposalId: reverseProposalId!,
    }),
    enabled: reverseProposalId !== undefined,
  });
};
